var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownDropDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 17,
    viewBox: "0 0 29 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5523 0.439323C27.9553 -0.146464 26.9874 -0.146463 26.3904 0.439323L14.5 12.1066L2.60962 0.43934C2.01263 -0.146446 1.04473 -0.146447 0.447737 0.43934C-0.149252 1.02513 -0.149251 1.97487 0.447738 2.56066L12.3381 14.2279L14.5 16.3492L16.6619 14.2279L28.5523 2.56064C29.1492 1.97486 29.1492 1.02511 28.5523 0.439323Z",
    fill: "#FF1616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownDropDownArrow);
export default __webpack_public_path__ + "static/media/DownDropDownArrow.8375d37d1579e881c89853193d2074b5.svg";
export { ForwardRef as ReactComponent };